export enum RoleType {
  Administrator = 0,
  Manager = 1,
  Editor = 2,
  Contributor = 3,
  Reviewer = 4,
  Custom = 5,
  DynamicRole = 6
}
